import styled from "styled-components";
import DesignConstants from "../../../../../../constants/DesignConstants";

export const AddVocabularyButtonWrapper = styled.div`
    display: flex;

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        justify-content: flex-start;

        button {
            height: auto;
            padding-top: ${DesignConstants.SPACES.XS};
            padding-bottom: ${DesignConstants.SPACES.XS};
            text-align: left;
        }

        button div {
            white-space: normal;
            text-align: left;
        }
    }
`;
